/**
 * Design material parameters at version 0.4.8 so that the migration will keep working even if the default parameters change.
 * The parameters exclude lists since those are filled in by the migration.
 * @module
 */
import * as THREE from "three";

export const legacyDefaultLayerParams = Object.freeze({
  enabled: false,
  srcID: "texture",
  uvTransformID: "layer",
  textureURL: "/static/textures/DV_Grunge_SpotsCloudsNoise_01_P.png",
  channel: 0,
  blendMode: "alpha",
  strength: 1,
  invertInput: false,
  colorCount: 2,
  color0: "#000000",
  color1: "#ffffff",
  color2: "#555555",
  color3: "#aaaaaa",
  color0Pos: 0.0,
  color1Pos: 1.0,
  color2Pos: 1.0,
  color3Pos: 1.0,
  scaleU: 16,
  scaleV: 16,
  translateU: 0,
  translateV: 0,
  rotate: 0, // in degrees
  maskID: "none",
  maskUvTransformID: "mask",
  sdfMaskRandomness: 0.0,
  invertMask: false,
  colorInfluence: 1.0,
  roughnessInfluence: 0.0,
  metalnessInfluence: 0.0,
  useForHeight: false,
  heightInfluence: 0.2,
  randomUvOffsetStrength: 0.0,
  randomMaskUniqueness: 0.0,
});

export const legacyDefaultMaskParams = Object.freeze({
  textureURL: "/static/textures/DV_Grunge_SpotsCloudsNoise_01_P.png",
  channel: 0,
  scaleU: 50,
  scaleV: 50,
  translateU: 0,
  translateV: 0,
  rotate: 0, // in degrees
  strength: 0.75,
  contrast: 0,
});

export const legacyDefaultSdfPattern = Object.freeze({
  enabled: false,
  slope: 0, //in degrees
  rotation: 0, //in degrees
  cutXfromY: false,
  cutXfromYScale: 0,
  varyHeight: false,
  varyHeightScale: 0,
  xSize: 5,
  ySize: 1,
  zSize: 1.5,
  xOffset: 0,
  yOffset: 0,
  zOffset: 0,
  xDistance: 10,
  yDistance: 10,
  useBevels: false,
  bevelDistanceX: 0.0,
  bevelDistanceY: 0.0,
  bevelDistanceZ: 0.0,
  roundSidesMode: "none",
  roundStrength: 0.05,
});

export const legacyDefaultSdfParams = Object.freeze({
  maskOnly: true,
  useShadows: false,
  useAO: false,
  randomMaskSeed: 1.0,
  depth: 1.0,
  aoStrength: 1,
  aoTolerance: 0.5,

  //random tiles params

  useRandomTiles: false,
  tileRotation: 0,
  tileSizeX: 20.0,
  tileSizeY: 20.0,
  tileSizeZ: 1.0,
  tileOffsetX: 0,
  tileOffsetY: 0,
  tileOffsetZ: 0,
  tileRoundness: 0.1,
  tileEdgeSize: 0.4,
  tileVariability: 0.5,
  tileVaryHeightStr: 0.0,
  tileNumCuts: 2,
  tileSeed: 1.0,
  tileYCutFirst: true,
  tileXVariation: false,
});

export const legacyDefaultDesignMaterialParams = Object.freeze({
  version: "0.4.8",
  type: "material",

  allowUsingTemplateOnItsOwn: true,
  compatibleColorLibraries: [],
  compatibleLayerConfigLibraries: [],

  rotateAllLayers: 0,

  color: "#808080",
  transparent: false,
  opacity: 1.0,
  useEnvMap: false,
  envMapIntensity: 0.5,
  roughness: 1.0,
  metalness: 0.0,
  reflectivity: 0.5,
  useSpecularColor: false,
  specularColor: "#101010",
  clearcoat: 0.0,
  clearcoatRoughness: 1.0,
  side: THREE.FrontSide,
  shadowSide: THREE.DoubleSide,
  heightMapFilterWidth: 0.7,
  selfAoStrength: 0.5,
  normalMapURL: "",
  normalMapStrength: 1.0,
  normalMapScaleU: 50,
  normalMapScaleV: 50,
  normalMapTranslateU: 0,
  normalMapTranslateV: 0,
  normalMapRotation: 0,
  randomizeShader: false,
  randomizeShaderSeed: 0,
  disableSSAO: false,
  mainMaskTexURL: "",
  mainMaskChannel: 0,
  mainMaskScaleU: 50,
  mainMaskScaleV: 50,
  mainMaskTranslateU: 0,
  mainMaskTranslateV: 0,
  mainMaskRotation: 0,
  hatchMaterialId: "Auto",
});
